import FacilityList from "../../features/marketingExecutive/FacilityList"

const FacilityListApartmentPage = () => {
  return <FacilityList/>
}

export default FacilityListApartmentPage